export default __webpack_public_path__ + "static/media/img4.5aa24fc7.PNG";